import { useContext, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { FormParserContext } from 'src/contexts/form.context';
import { InputContext } from 'src/contexts/input.context';
import { SearchableDropdown as SearchableDropdownComponent } from 'src/components/InputRenderers';
import { ifTrue } from 'src/tools/logic.tools';
import { getAllLevels } from 'src/store/levels/levels.getters';
import { requestAllLevels } from 'src/store/levels/levels.actions';
import { ID } from 'src/models';
import { getCustomIsLoading } from 'src/store/loading/loading.reducer';

export function LevelSearchableDropdown() {
  const { value, script, onChange, error } = useContext(FormParserContext);

  const items = useSelector(getAllLevels);

  const isLoading = useSelector(getCustomIsLoading)('levels');

  const dispatch = useDispatch();

  useEffect(() => {
    if (!items) dispatch(requestAllLevels());
  }, [dispatch, items]);

  function handleOnChange(newValue: ID) {
    onChange(newValue);
  }

  return (
    <InputContext.Provider
      value={{
        classNames: { container: 'w-100p', input: ifTrue(error, 'with-error') },
        value: value,
        onChange: handleOnChange,
        isDisabled: script.isDisabled,
        isAutoFocus: script.autofocus,
        placeholder: script.placeholder,
        isLoading,
        items,
      }}
    >
      <SearchableDropdownComponent isSearchable isStrictSearch />
    </InputContext.Provider>
  );
}
